module.exports = __webpack_public_path__ + "static/media/Waving.d9c6deae.gif";